import { useCartContext } from '../lib/cart'
import { useTestKitProducts } from '../lib/products/hooks/useTestKitProducts'
import useUserCategory from './useUserCategory'

type UseIsTruemedAvailableParams = {
  skus?: string[]
  // If true, will check the products in the cart instead of the provided skus
  checkCartProducts?: boolean
}
const inelegibleSkus = ['BLNDBT', 'PBSSPM', 'NOSTRIP', 'PBSLEM', 'PERM60']

const useIsTruemedAvailable = ({
  skus: externalSkus = [],
  checkCartProducts,
}: UseIsTruemedAvailableParams) => {
  const { isTestKitSku } = useTestKitProducts()
  const { userCategory } = useUserCategory()
  const { cart } = useCartContext()

  const cartSkus = cart?.items?.map((item) => item?.product.sku)
  const skus = checkCartProducts ? cartSkus : externalSkus

  if (userCategory === 'other_professional' || userCategory === 'practitioner') {
    return false
  }

  const haveTruemedPaymentMethod = cart?.available_payment_methods?.some(
    (method) => method?.code === 'designsforhealth_truemed',
  )

  if (!haveTruemedPaymentMethod) {
    return false
  }

  const delayedBillingRequired = skus?.some((sku) => sku && isTestKitSku(sku))

  if (delayedBillingRequired) {
    return false
  }

  const isAnyProductEligible = skus?.some((sku) => sku && !inelegibleSkus.includes(sku))

  return isAnyProductEligible
}

export default useIsTruemedAvailable
